<template>
    <div>
        <Toolbar>
            <BackButton/>
        </Toolbar>

        <Card>
            <template v-slot:title>{{ __('subscriptions.stores.change') }}</template>

            <p>
                {{ __('subscriptions.stores.change_description') }}
            </p>

            <div class="row">
                <div class="col-md-6 col">
                    <div class="form-group">
                        <label class="font-weight-bold">
                            {{ __('subscriptions.stores.add_or_remove') }}
                        </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <select class="form-control" v-model="bookStoresRequest.action">
                                    <option value="add">+</option>
                                    <option value="remove">-</option>
                                </select>
                            </div>
                            <input class="form-control" type="number" v-model="bookStoresRequest.count">
                        </div>
                        <span
                            class="form-text text-muted">{{ __('subscriptions.select_slots') }}</span>
                        <FormErrors :error="bookStoresRequest.errors.count"/>
                    </div>
                </div>
            </div>

            <!-- TODO: show additional cost -->
            <div class="row">
                <div class="col-md-6 col">
                    <div class="form-group">
                        <label class="font-weight-bold">
                            {{ __('subscriptions.change_of_monthly_payments') }}
                        </label>
                        <div class="font-size-lg">
                            <div v-for="priceDifference in priceDifferences" class="px-2 py-1">
                                <Price :value="priceDifference.total"/>
                                / {{ __('subscriptions.invoicing.periods.' + priceDifference.period) }}
                            </div>
                            <div class="border-top border-top-dotted font-weight-bold text-muted px-2 py-1">
                                <Price :value="priceDiffTotalNet"/> {{ __('general.net') }}
                            </div>
                            <div class="font-weight-bold text-muted px-2 py-1">
                                <Price :value="priceDiffTotalNet * taxRate"/> {{ __('general.vat_with_value', {value: 19}) }}
                            </div>
                            <div class="border-top font-weight-bold px-2 py-1">
                                <Price :value="priceDiffTotal"/> {{ __('general.total') }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <template v-slot:footer>
                <button class="btn btn-primary" :disabled="!(bookStoresRequest.count > 0)" @click="book">
                    <i class="fas fa-arrow-circle-right"/>
                    {{ __('subscriptions.book') }}
                </button>
            </template>
        </Card>
    </div>
</template>

<script>
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import Card from "@components/Cards/Card.vue";
import FormErrors from "@components/Form/FormErrors.vue";
import Price from "@components/Price.vue";

export default {
    components: {Price, FormErrors, Card, BackButton, Toolbar},

    props: {
        subscription: Object,
        paidStoresCount: Number
    },

    data() {
        return {
            bookStoresRequest: this.$inertia.form({
                action: 'add',
                count: 0
            }),
            taxRate: 0.19
        }
    },

    methods: {
        book() {
            this.bookStoresRequest.post(this.$route('subscriptions.stores.book'))
        }
    },

    computed: {
        priceDifferences() {
            let priceDifferences = [];

            for (let priceCondition of this.subscription.pricing_conditions) {
                let total = 0.0;
                if (priceCondition.invoicing_type === 'per_store') {
                    total += priceCondition.value * this.bookStoresRequest.count;
                } else {
                    total += priceCondition.value;
                }

                if (this.bookStoresRequest.action === 'remove') {
                    total *= -1;
                }

                priceDifferences.push({
                    total: total,
                    period: priceCondition.invoicing_period
                });
            }

            return priceDifferences
        },

        priceDiffTotalNet() {
            let total = 0.0;

            for (let priceDifference of this.priceDifferences) {
                total += priceDifference.total
            }

            return total
        },

        priceDiffTotal() {
            return this.priceDiffTotalNet * (1 + this.taxRate)
        }
    }
}
</script>
